<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <app-saved-dashboard-view></app-saved-dashboard-view>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <!-- TODO Obsłużyć pozostałe typy -->
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="requestNewSegmentsProcessing()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Process new Segments
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_1_monthly_last_year.png"
                        />
                    </div>
                    <div nz-col nzSpan="12" *ngFor="let link of [case_1]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [daily_new_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div> -->
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_2_monthly_3M.png"
                        />
                    </div>
                    <div nz-col nzSpan="12" *ngFor="let link of [case_2]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [daily_new_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div> -->
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_3_revenue_yearly.png"
                        />
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [case_3_revenue_yearly]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [daily_new_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div> -->
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_4_daily_data.png"
                        />
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [case_4_revenue_daily]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [daily_new_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div> -->
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_5_single_data_point.png"
                        />
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [case_5_single_data_point]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [daily_new_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div> -->
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_6_revenue_weekly.png"
                        />
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [case_6_revenue_weekly]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_7_cloudsave_commits_count.png"
                        />
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [case_7_cloudsave_commits_count]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\case_8.png"
                        />
                    </div>
                    <div nz-col nzSpan="12" *ngFor="let link of [case_8]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>

                <nz-divider
                    nzText="Known Issues"
                    nzOrientation="left"
                ></nz-divider>

                <div nz-row class="row-center" [nzGutter]="5">
                    <div nz-col nzSpan="12">
                        <img
                            src="assets\images\dashboards\dev-echarts\known_issues_1_lifetime_split_country.png"
                        />
                    </div>
                    <div nz-col nzSpan="12">
                        <p class="vcenter">
                            In bar charts, when the data range is very wide
                            (e.g. lifetime) and we additionally apply split by
                            Country, the X-axis labels begin to narrow. This is
                            because there are many columns next to each other on
                            the chart. The minimum column width used by Echarts
                            is not able to fit them all in one row, causing the
                            chart to break apart. The problem is caused by the
                            number of columns, not by the X-axis.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
